const TopUp = () => {
  return (
    <div className="TopUp">
        <h1>TopUp!</h1>
    </div>
  );
};

export default TopUp;
